import { render, staticRenderFns } from "./blog-1.vue?vue&type=template&id=78671b46&scoped=true"
import script from "./blog-1.vue?vue&type=script&lang=js"
export * from "./blog-1.vue?vue&type=script&lang=js"
import style0 from "./blog-1.vue?vue&type=style&index=0&id=78671b46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78671b46",
  null
  
)

export default component.exports